
import { NgModule, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; // For ngModel
import { Router, RouterModule } from '@angular/router';
// import { Component, ElementRef, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';

import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { ProductService } from '../pages/service/product.service';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { Product, ProductService } from '../service/product.service';
import { Location } from '@angular/common';
import { UserService } from '../pages/service/user.service'; // <-- Import UserService
import { getPersistedItemDetailsVersion, itemDetailsRouteCommands } from '../item-details/item-details-routing.util';
import { MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu'; // ✅ Import this
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';
import {
    CreditLimitDialogData,
    CreditLimitDialogKind,
    CreditRestrictionResult,
    CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH,
    formatCreditLimitDialogNote,
    mapCreditRestrictionToDialog,
    getCreditLimitBypassContactNote,
    isCreditLimitApprovedOnOrder,
    isCreditLimitSoftBypassUser,
    isCreditNoteOrder,
    isCreditRestrictionActive,
    logCreditLimitBypassDebug,
    resolveCreditLimitPageAction,
    resolveCreditRestrictionFromGenerateOutput,
    resolveUserEmail,
    shouldSkipCreditLimitProcessingGate
} from '../item-details/item-utils';
import { CreditLimitDialogContentComponent } from '../item-details/credit-limit-dialog-content/credit-limit-dialog-content.component';
import { MarginApprovalDialogContentComponent } from '../item-details/margin-approval-dialog-content/margin-approval-dialog-content.component';
import {
    buildMarginApprovalSummary,
    getMarginApproverProceedNote,
    getMarginBlockedApprovalNotice,
    getMarginBypassContactNote,
    isMarginApprovalEnabledForDivision,
    isMarginApprovalUserFromStorage,
    resolveMarginAssistanceContactEmails,
    resolveMarginBlockedContactEmails,
    resolveMarginWarehouse,
    resolveOrderMinimumMarginPercent,
    isMarginApprovedOnOrder,
    shouldSkipMarginProcessingGate
} from '../item-details/margin-approval.utils';
import { ItemDetailsService } from '../services/item-details.service';
import { MarginApprovalSummary, MarginValidationService } from '../services/margin-validation.service';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { timeout } from 'rxjs';

/** Expanded invoice row for preview/print pagination (item + pre/post text blocks). */
export type InvoicePrintRow =
    | { kind: 'headerPre' | 'headerPost'; text: string }
    | { kind: 'item'; line: any }
    | { kind: 'linePre' | 'linePost'; text: string; parentLineNo: number };

@Component({
  selector: 'app-preivew-invoice',
    imports: [
        AutoCompleteModule,
        // AppTopbar,
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        CreditLimitDialogContentComponent,
        MarginApprovalDialogContentComponent
    ],
  templateUrl: './preivew-invoice.component.html',
  styleUrl: './preivew-invoice.component.scss',
    providers: [ConfirmationService, MessageService] // <-- Add providers here
})
export class PreivewInvoiceComponent implements OnInit, OnDestroy {
    item: any;
    readonly a4HeightPx = 1122; // A4 height in pixels at 96dpi
    @ViewChild('header') headerRef!: ElementRef;
    @ViewChild('footer') footerRef!: ElementRef;
    @ViewChild('summaryDiv') summaryRef!: ElementRef;
    @ViewChild('itemsTable') itemsTableRef!: ElementRef;
    @ViewChild('mainContent') mainContentRef!: ElementRef;
    isPreviewMode: boolean = false;
    isFromSyncFlow: boolean = false;
    viewOnly = false;
    skipLock = false;
    creditLimitBlocked = false;
    creditLimitBlockedDialogVisible = false;
    creditLimitProceedDialogVisible = false;
    private creditLimitProceedCallback: (() => void) | null = null;
    private creditLimitAcknowledged = false;
    creditLimitApprovalReason = '';
    creditLimitApprovalSubmitting = false;
    /** Last generateOutput payload — used to re-check credit when clicking Sync to M3. */
    private lastGenerateOutputData: any = null;
    private pendingCreditRestriction: CreditRestrictionResult | null = null;
    marginSnapshot: any = null;
    private marginCheckLines: any[] = [];
    marginApprovalProceedDialogVisible = false;
    marginApprovalBlockedDialogVisible = false;
    marginApprovalProceedLabel = 'Sync to M3';
    marginApprovalSummary: MarginApprovalSummary | null = null;
    marginApprovalContactNote = '';
    marginApprovalContactEmails: string[] = [];
    marginApprovalBlockedNotice = '';
    marginApprovalProceedNote = getMarginApproverProceedNote();
    marginApprovalReason = '';
    marginApprovalSubmitting = false;
    private marginApprovalProceedCallback: (() => void) | null = null;
    creditLimitDialogKind: CreditLimitDialogKind = 'exposure';
    creditLimitDialogData: CreditLimitDialogData | null = null;
    creditLimitDialogNood = 0;
    creditLimitDialogOdud = 0;
    creditLimitContactNote = '';
    activeDivisionId = '';
    itemList: any[] = [];
    totalAmountAfterDiscount = 0;
    @ViewChild('invoice') invoiceElement!: ElementRef;
    paginatedContent: InvoicePrintRow[][] = [];
    supplierDetails = {
        supplerVrno: '',
        coa1: '',
        phno: '',
        coa2: '',
        coa3: '',
        coa4: ''
    };
    customerDetails = {
        customerVrno: '',
        CUA1: '',
        CUA2: '',
        CUA3: '',
        CUA4: '',
        phoneNumber: '',
        email: ''
    };
    invoiceDetails = {
        invoiceNo: '',
        customerNo: '',
        date: '',
        orderNumber: '',
        referenceOrderNumber: '',
        userIdResponsible: ''
    };
    threshold: number = 10; // <-- Add this line
    lineDetails: any[] = [];
    /** Order-level pre/post texts for order confirmation (CO02 / CO01). */
    headerPreTexts: string[] = [];
    headerPostTexts: string[] = [];
    // Pagination: variable items per page based on wrapped description lines
    private readonly PAGE_LINE_BUDGET = 24;
    private readonly DESC_CHARS_PER_LINE = 30;
    private readonly SUMMARY_RESERVED_LINES = 6;
    /** Print-only: safer budget so wrapped descriptions are not clipped by overflow. */
    private readonly PRINT_PAGE_LINE_BUDGET = 24;
    private readonly PRINT_DESC_CHARS_PER_LINE = 28;
    private readonly PRINT_SAFETY_ROWS = 2;
    ngAfterViewInit() {
        setTimeout(() => {
            const headerHeight = this.headerRef?.nativeElement.offsetHeight || 0;
            const footerHeight = this.footerRef?.nativeElement.offsetHeight || 0;
            const summaryHeight = this.summaryRef?.nativeElement.offsetHeight || 0;
            const itemsTableHeight = this.itemsTableRef?.nativeElement.offsetHeight || 0;
            const mainContentHeight = this.mainContentRef?.nativeElement.offsetHeight || 0;
            const totalContentHeight = headerHeight + footerHeight + summaryHeight + itemsTableHeight + mainContentHeight;

            console.log('Header height:', headerHeight, 'px');
            console.log('Footer height:', footerHeight, 'px');
            console.log('Summary height:', summaryHeight, 'px');
            console.log('Items table height:', itemsTableHeight, 'px');
            console.log('Total content height:', totalContentHeight, 'px');
            console.log('Main content height:', mainContentHeight, 'px');
            console.log('A4 page height:', this.a4HeightPx, 'px');
            if (totalContentHeight > this.a4HeightPx) {
                console.warn('Content exceeds A4 page height!');
            } else {
                console.info('Content fits within A4 page height.');
            }
        }, 500); // Wait for DOM to render
    }
    summaryOnExtraPage: boolean = false; // Already present
    summary = {
        grossValue: 0,
        totalDiscountValue: 0,
        netAmount: 0,
        vatAmount: 0,
        totalOrderValue: 0,
        totalGrossWeight: 0,
        vatPercent: 0,
        taxBase: 0,
        vatSummaries: [] as { vatPercentage: number; totalNetAmount: number; totalVatAmount: number }[]
    };
    skipReleaseLock = false;
    confirmInvoiceDialogVisible = false;
    sendPreviewMailDialogVisible = false;
    sendPreviewMailTo = '';
    sendPreviewMailLoading = false;
    private getRowLineCost(line: any): number {
        const desc = (line?.description ?? '').toString();
        const len = desc.length;
        const lines = Math.ceil(Math.max(1, len) / this.DESC_CHARS_PER_LINE);
        return Math.max(1, lines);
    }

    /** Item row plus attached line pre/post rows (same budget rules as print rows). */
    private getLineBlockCost(line: any): number {
        let cost = this.getRowLineCost(line);
        for (const text of this.normalizeTextList(line?.linePreTexts)) {
            cost += Math.min(3, Math.max(1, Math.ceil(text.length / this.DESC_CHARS_PER_LINE)));
        }
        for (const text of this.normalizeTextList(line?.linePostTexts)) {
            cost += Math.min(3, Math.max(1, Math.ceil(text.length / this.DESC_CHARS_PER_LINE)));
        }
        return cost;
    }

    private paginateByWrappedLines(lines: any[]): { pages: any[][]; summaryOnExtraPage: boolean } {
        const pages: any[][] = [];
        let current: any[] = [];
        let used = 0;

        for (const line of (lines || [])) {
            const cost = this.getLineBlockCost(line);
            if (current.length > 0 && used + cost > this.PAGE_LINE_BUDGET) {
                pages.push(current);
                current = [];
                used = 0;
            }
            current.push(line);
            used += cost;
        }

        if (pages.length === 0 || current.length > 0) {
            pages.push(current);
        }

        const lastPage = pages[pages.length - 1] || [];
        const lastUsed = lastPage.reduce((sum, l) => sum + this.getLineBlockCost(l), 0);
        const remaining = this.PAGE_LINE_BUDGET - lastUsed;
        const summaryOnExtraPage = remaining < this.SUMMARY_RESERVED_LINES;

        return { pages, summaryOnExtraPage };
    }

    private getPrintRowLineCost(row: InvoicePrintRow | any): number {
        if (row && typeof row === 'object' && 'kind' in row) {
            const printRow = row as InvoicePrintRow;
            if (printRow.kind === 'item') {
                const desc = (printRow.line?.description ?? '').toString().trim();
                if (!desc) {
                    return 1;
                }
                return Math.min(3, Math.max(1, Math.ceil(desc.length / this.PRINT_DESC_CHARS_PER_LINE)));
            }
            const text = (printRow.text ?? '').toString().trim();
            if (!text) {
                return 1;
            }
            return Math.min(3, Math.max(1, Math.ceil(text.length / this.PRINT_DESC_CHARS_PER_LINE)));
        }
        const desc = (row?.description ?? '').toString().trim();
        if (!desc) {
            return 1;
        }
        return Math.min(3, Math.max(1, Math.ceil(desc.length / this.PRINT_DESC_CHARS_PER_LINE)));
    }

    /** Print-only pagination with safety margin; preview keeps wrap-aware line chunks. */
    private paginateForPrint(rows: InvoicePrintRow[]): { pages: InvoicePrintRow[][]; summaryOnExtraPage: boolean } {
        const pages: InvoicePrintRow[][] = [];
        let current: InvoicePrintRow[] = [];
        let used = 0;
        const maxUsed = this.PRINT_PAGE_LINE_BUDGET - this.PRINT_SAFETY_ROWS;

        for (const row of rows || []) {
            const cost = this.getPrintRowLineCost(row);
            if (current.length > 0 && used + cost > maxUsed) {
                if (row.kind === 'item') {
                    const movedPres: InvoicePrintRow[] = [];
                    while (current.length > 0 && current[current.length - 1].kind === 'linePre') {
                        const pre = current.pop() as InvoicePrintRow;
                        used -= this.getPrintRowLineCost(pre);
                        movedPres.unshift(pre);
                    }
                    if (current.length > 0) {
                        pages.push(current);
                    }
                    current = [...movedPres];
                    used = movedPres.reduce((sum, r) => sum + this.getPrintRowLineCost(r), 0);
                } else {
                    pages.push(current);
                    current = [];
                    used = 0;
                }
            }
            current.push(row);
            used += cost;
        }

        if (pages.length === 0 || current.length > 0) {
            pages.push(current);
        }

        const lastPage = pages[pages.length - 1] || [];
        const lastUsed = lastPage.reduce((sum, r) => sum + this.getPrintRowLineCost(r), 0);
        const remaining = maxUsed - lastUsed;
        const summaryOnExtraPage = remaining < this.SUMMARY_RESERVED_LINES;

        return { pages, summaryOnExtraPage };
    }

    private normalizeTextList(raw: unknown): string[] {
        if (!Array.isArray(raw)) {
            return [];
        }
        return raw
            .map((v) => String(v ?? '').trim())
            .filter((v) => !!v);
    }

    private resolvePreviewLineNetExVat(line: any): number {
        if (line.netAmount != null && line.netAmount !== 0) {
            return line.netAmount;
        }
        const gross = line.grossAmount ?? line.quantity * line.salesPrice;
        const disc = line.discountPercent || 0;
        return gross * (1 - disc / 100);
    }

    private resolvePreviewPpu(line: any, netExVat: number): number {
        const pcs = Number(line.pcs) || 0;
        const qty = Number(line.quantity) || 0;
        if (pcs <= 0 || qty <= 0) {
            return 0;
        }
        return netExVat / qty / pcs;
    }

    private buildPrintRows(lines: any[], headerPre: string[], headerPost: string[]): InvoicePrintRow[] {
        const rows: InvoicePrintRow[] = [];
        for (const text of headerPre || []) {
            rows.push({ kind: 'headerPre', text });
        }
        for (const line of lines || []) {
            for (const text of this.normalizeTextList(line?.linePreTexts)) {
                rows.push({ kind: 'linePre', text, parentLineNo: Number(line?.position ?? line?.lineNo) || 0 });
            }
            rows.push({ kind: 'item', line });
            for (const text of this.normalizeTextList(line?.linePostTexts)) {
                rows.push({ kind: 'linePost', text, parentLineNo: Number(line?.position ?? line?.lineNo) || 0 });
            }
        }
        for (const text of headerPost || []) {
            rows.push({ kind: 'headerPost', text });
        }
        return rows;
    }

    /** Preview: wrap-aware line chunks, then expand each page with pre/post for that slice. */
    private buildPreviewPages(lines: any[]): InvoicePrintRow[][] {
        const paginated = this.paginateByWrappedLines(lines || []);
        const chunks = paginated.pages;
        if (chunks.length === 0) {
            return [this.buildPrintRows([], this.headerPreTexts, this.headerPostTexts)];
        }
        return chunks.map((chunk, idx) => {
            const isFirst = idx === 0;
            const isLast = idx === chunks.length - 1;
            return this.buildPrintRows(
                chunk,
                isFirst ? this.headerPreTexts : [],
                isLast ? this.headerPostTexts : []
            );
        });
    }

    pageHeaderPres(pageRows: InvoicePrintRow[]): string[] {
        return (pageRows || []).filter((r) => r.kind === 'headerPre').map((r) => (r as { text: string }).text);
    }

    pageHeaderPosts(pageRows: InvoicePrintRow[]): string[] {
        return (pageRows || []).filter((r) => r.kind === 'headerPost').map((r) => (r as { text: string }).text);
    }

    pageTableRows(pageRows: InvoicePrintRow[]): InvoicePrintRow[] {
        return (pageRows || []).filter((r) => r.kind === 'item' || r.kind === 'linePre' || r.kind === 'linePost');
    }

    private applyPrintPaginationForCapture(): { savedPages: InvoicePrintRow[][]; savedSummary: boolean } {
        const savedPages = this.paginatedContent;
        const savedSummary = this.summaryOnExtraPage;
        const printRows = this.buildPrintRows(this.lineDetails, this.headerPreTexts, this.headerPostTexts);
        const printPaginated = this.paginateForPrint(printRows);
        this.paginatedContent = printPaginated.pages;
        this.summaryOnExtraPage = printPaginated.summaryOnExtraPage;
        this.cdr.detectChanges();
        return { savedPages, savedSummary };
    }

    private restorePrintPagination(savedPages: InvoicePrintRow[][], savedSummary: boolean): void {
        this.paginatedContent = savedPages;
        this.summaryOnExtraPage = savedSummary;
        this.cdr.detectChanges();
    }

    private rewriteRelativeAssetUrls(html: string): string {
        const baseHref =
            document.querySelector('base')?.href ||
            `${window.location.origin}${window.location.pathname.replace(/\/[^/]*$/, '/')}`;
        return html.replace(/(src=["'])(?!https?:|data:|blob:)([^"']+)/gi, (_m, prefix: string, path: string) => {
            try {
                return prefix + new URL(path, baseHref).href;
            } catch {
                return prefix + path;
            }
        });
    }

    divisionId: string = ''; // <-- Add this line
    div1: string = '';
    constructor(
        private http: HttpClient,
        private router: Router,
        private userService: UserService,
        private location: Location,
        private messageService: MessageService,
        private loaderService: LoaderService,
        private productService: ProductService,
        private confirmationService: ConfirmationService,
        private inMemoryStorage: InMemoryStorageService,
        private itemDetailsService: ItemDetailsService,
        private marginValidationService: MarginValidationService,
        private cdr: ChangeDetectorRef
    ) {
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state as any;
        this.item = state?.item;
        this.itemList = state?.itemList || [];
        this.creditLimitAcknowledged = state?.creditLimitAcknowledged === true;
    }
    goBack() {
        this.skipReleaseLock = false; // Set flag to skip lock release
        // if (window.history.length > 1) {
        //     this.location.back();
        // } else {
        this.router.navigate(['/Orders1']);
        // }
    }
   get headerImage(): string {
        switch (this.div1) {
          case '400': return 'assets/Header.jpg';
          case '300': return 'assets/header_FR.jpg';
          case '100': return 'assets/header_DE.jpg';
          default: return 'assets/Header.jpg';
        }
      }
    get footerImage(): string {
        switch (this.div1) {
          case '400':
            return 'assets/Footer.jpg';
          case '300':
            return 'assets/footer_FR.jpg';
          case '100':
            return 'assets/footer_DE.jpg';
          default:
            return 'assets/Footer.jpg'; // fallback
        }
      }
    goToOrder() {
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }

        // Navigate to item details page with order number and state
        // Set flag to skip lock release since user is going to edit the order
        this.skipReleaseLock = true;
        const division = this.userService.getDivisionId() || this.item?.divisionId || '';
        const version = getPersistedItemDetailsVersion(division);
        this.router.navigate(itemDetailsRouteCommands(version, this.item.orderNumber), {
            state: {
                product: this.item,
                itemList: this.itemList
            }
        });
    }

    // Define the page height (adjust based on your layout)
    pageHeight: number = 1122; // example for A4 at 96dpi or adjust as needed
    lockRefreshInterval: any = null;
    // Track content height on the last page (to be calculated during rendering)
    lastPageContentHeight: number = 0;

    // Summary block height (can be updated dynamically or hardcoded after testing)
    summaryHeight: number = 200; // adjust based on actual summary height

    // Flag to indicate if the summary needs to go on an extra page

    ngOnInit() {
        const navigation = this.router.getCurrentNavigation();
        const state = navigation?.extras?.state || history.state;

        if (state) {
            this.viewOnly = state.viewOnly === true;
            this.skipLock = state.skipLock === true;
            if (this.skipLock) {
                this.skipReleaseLock = true;
            }
        }

        if (!this.skipLock) {
            this.startLockRefresh();
        }

        // Get divisionId from navigation state or userService
        const divisionId = this.userService.getDivisionId() || this.item?.divisionId || '100';
        this.div1 = divisionId;

        // Set language based on division
        if (divisionId === '100') {
            this.selectedLanguage = 'de';
        } else if (divisionId === '400') {
            this.selectedLanguage = 'nl';
        } else if(divisionId==='300'){
            this.selectedLanguage='fr'
        }else {
            this.selectedLanguage = 'en';
        }

        this.threshold = 6;
        console.log('Selected Language:', this.selectedLanguage, 'Threshold:', this.threshold);

        // Remove all dummy data assignments
        console.log('Item:', this.item);
        console.log('Item List:', this.itemList);
        console.log(this.itemList.length, 'Item Length');

        console.log(this.lineDetails, 'Item Details');
        // Use itemList for pagination if lineDetails is null or empty
        const sourceList = this.lineDetails && this.lineDetails.length ? this.lineDetails : this.itemList;
        const paginated = this.paginateByWrappedLines(sourceList);
        this.summaryOnExtraPage = paginated.summaryOnExtraPage;
        this.paginatedContent = this.buildPreviewPages(sourceList);

        // Example: get these from your navigation state or user service
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';

        this.div1 = divisionId;
        console.log('Company ID:', companyId, 'Division ID:', divisionId, 'Order Number:', orderNumber);

        if (state && state.item) {
            this.item = state.item;
            this.itemList = state.itemList || [];
            const companyId = this.userService.getCompanyId() || '';
            const divisionId = this.userService.getDivisionId() || '';
            console.log(state, 'state');
            console.log(state.isPreview, 'isPreview');

            const isPreview = state.isPreview || false;
            this.isFromSyncFlow = state.fromSync || false;
            this.creditLimitAcknowledged =
                state.creditLimitAcknowledged === true || this.creditLimitAcknowledged;
            console.log(this.isFromSyncFlow, 'isFromSyncFlow');
            console.log(this.isPreviewMode, 'isPreviewMode');
            this.fetchInvoiceData(this.item.orderNumber, companyId, divisionId, isPreview);
        }

        // this.fetchInvoiceData(orderNumber, companyId, divisionId);

    }
    onLanguageChange(lang: string) {
        this.selectedLanguage = lang;
        // No pagination or summary logic here
    }

    // chunkData(data: any[], size: number): any[][] {
    //     const chunks = [];
    //     for (let i = 0; i < data.length; i += size) {
    //         chunks.push(data.slice(i, i + size));
    //     }
    //     // If the last chunk is "full", add an empty chunk for summary/footer
    //     if (chunks.length && chunks[chunks.length - 1].length === size) {
    //         chunks.push([]);
    //     }
    //     return chunks;
    // }

    formatBBE(dateStr: string): string {
        if (!dateStr || dateStr.length !== 8) return dateStr || '';
        return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
    }

    getTotalAmountAfterDiscount(): number {
        return this.itemList.reduce((sum, item) => sum + item.amountAfterDiscount, 0);
    }
    getGrossValue(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    }
    getTotalDiscountValue(): number {
        return (this.itemList || []).reduce((sum, row) => sum + ((Number(row.amount) * Number(row.discount)) / 100 || 0), 0);
    }
    getNetAmount(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amountAfterDiscount) || 0), 0);
    }
    getVatAmount(): number {
        return (this.itemList || []).reduce((sum, row) => sum + (Number(row.vatAmount) || (Number(row.amountAfterDiscount) * Number(row.vat)) / 100 || 0), 0);
    }
    getOrderValue(): number {
        return this.getNetAmount() + this.getVatAmount();
    }

    printInvoice() {
        this.messageService.add({
            severity: 'success',
            summary: 'Printing Invoice',
            detail: 'Please wait while the invoice is being prepared for printing.',
            life: 1000
        });

        const { savedPages, savedSummary } = this.applyPrintPaginationForCapture();
        let printContents = this.rewriteRelativeAssetUrls(this.invoiceElement.nativeElement.innerHTML);
        this.restorePrintPagination(savedPages, savedSummary);

        const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
            .map((node) => node.outerHTML)
            .join('\n');

        let printTitle = 'Invoice';
        if (this.isPreviewMode) {
            const orderNumber = this.invoiceDetails?.orderNumber || this.item?.orderNumber || '';
            printTitle = orderNumber ? `Preview_${orderNumber}` : 'Preview';
        } else {
            const invoiceNo = this.invoiceDetails?.invoiceNo || '';
            printTitle = invoiceNo || 'Invoice';
        }

        const popupWin = window.open('', '_blank', 'width=1000,height=800');
        if (!popupWin) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Print blocked',
                detail: 'Please allow pop-ups for this site to print the invoice.',
                life: 5000
            });
            return;
        }
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>${printTitle}</title>
          ${styles}
          <style>
            body { background: #fff !important; }
            .invoice-wrapper { box-shadow: none !important; border-radius: 0 !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
         
            .p-toolbar, .p-button-sm, .p-button-secondary { display: none !important; }
            @media print {
              .invoice-wrapper { page-break-after: always; }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
        popupWin.document.close();
    }
    exportToPDF() {
        this.messageService.add({
            severity: 'success',
            summary: 'Exporting to PDF',
            detail: 'Please wait while the invoice is being prepared for PDF export.',
            life: 1000
        });

        const { savedPages, savedSummary } = this.applyPrintPaginationForCapture();
        const element = this.invoiceElement.nativeElement;
        element.classList.add('pdf-export');

        const wrappers: HTMLElement[] = Array.from(element.querySelectorAll('.invoice-wrapper'));
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const finishExport = () => {
            this.restorePrintPagination(savedPages, savedSummary);
            element.classList.remove('pdf-export');
        };

        const renderPage = (idx: number) => {
            if (idx >= wrappers.length) {
                let filename = 'Invoice.pdf';
                if (this.isPreviewMode) {
                    const orderNumber = this.invoiceDetails?.orderNumber || this.item?.orderNumber || '';
                    filename = orderNumber ? `Preview_${orderNumber}.pdf` : 'Preview.pdf';
                } else {
                    const invoiceNo = this.invoiceDetails?.invoiceNo || '';
                    filename = invoiceNo ? `${invoiceNo}.pdf` : 'Invoice.pdf';
                }
                pdf.save(filename);
                finishExport();
                return;
            }
            html2canvas(wrappers[idx], { scale: 2 }).then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const imgWidth = pageWidth;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

                if (idx > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight > pageHeight ? pageHeight : imgHeight);

                renderPage(idx + 1);
            }).catch(() => {
                finishExport();
            });
        };

        renderPage(0);
    }

    /**
     * On preview load: store credit restriction for Sync / Confirm gates.
     * Listed approvers may view preview and get the proceed dialog on Sync.
     * Non-listed users see preview normally; Overdue Balance popup on Sync click.
     */
    private handleCreditLimitFromGenerateOutput(data: any, divisionId: string): void {
        this.lastGenerateOutputData = data;
        this.pendingCreditRestriction = null;

        if (
            this.creditLimitAcknowledged ||
            isCreditLimitApprovedOnOrder(this.item) ||
            isCreditLimitApprovedOnOrder(data) ||
            isCreditLimitApprovedOnOrder(data?.invoiceDetails)
        ) {
            this.creditLimitBlocked = false;
            return;
        }

        logCreditLimitBypassDebug('preview-invoice', divisionId, this.inMemoryStorage, 'sync');
        const { action, restriction } = resolveCreditLimitPageAction(data, divisionId, this.inMemoryStorage, 'sync');

        if (action === 'none' || !restriction) {
            this.creditLimitBlocked = false;
            return;
        }

        this.configureCreditLimitDialog(restriction);
        this.pendingCreditRestriction = restriction;
        this.creditLimitBlocked = false;
    }

    /** Salesperson hard-block on Sync: show credit-limit popup only (BLCD=2 is set on draft save). */
    private applyCustomerCreditBlockThenHardBlock(restriction?: CreditRestrictionResult | null): void {
        if (restriction) {
            this.configureCreditLimitDialog(restriction);
        }
        const divisionId = String(this.getMarginDivisionId() || this.inMemoryStorage.get('division') || '');
        this.creditLimitContactNote = getCreditLimitBypassContactNote('sync', divisionId);
        this.creditLimitBlocked = true;
        this.creditLimitBlockedDialogVisible = true;
    }

    /** Credit gate for Sync to M3 / Confirm & Invoice. Returns true if caller must stop. */
    private handleCreditLimitBeforeSyncOrInvoice(onAllowed: () => void): boolean {
        const divisionId = String(this.getMarginDivisionId() || this.inMemoryStorage.get('division') || '');
        const data = this.lastGenerateOutputData;
        if (
            shouldSkipCreditLimitProcessingGate(this.item?.referenceOrderId, this.item) ||
            isCreditLimitApprovedOnOrder(this.item) ||
            isCreditLimitApprovedOnOrder(data) ||
            isCreditLimitApprovedOnOrder(data?.invoiceDetails)
        ) {
            return false;
        }

        let restriction = this.pendingCreditRestriction;
        if (!restriction && data) {
            restriction = resolveCreditRestrictionFromGenerateOutput(data);
        }

        if (this.creditLimitBlocked) {
            this.creditLimitBlockedDialogVisible = true;
            return true;
        }

        if (!restriction || !isCreditRestrictionActive(restriction)) {
            return false;
        }

        logCreditLimitBypassDebug('preview-invoice:SyncToM3', divisionId, this.inMemoryStorage, 'sync');
        this.configureCreditLimitDialog(restriction);

        if (isCreditLimitSoftBypassUser(resolveUserEmail(this.inMemoryStorage), divisionId, 'sync')) {
            this.creditLimitApprovalReason = '';
            this.creditLimitApprovalSubmitting = false;
            this.creditLimitProceedCallback = () => onAllowed();
            this.creditLimitProceedDialogVisible = true;
            return true;
        }

        this.applyCustomerCreditBlockThenHardBlock(restriction);
        return true;
    }

    get canSubmitCreditLimitApproval(): boolean {
        return this.creditLimitApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
    }

    get canSubmitMarginApproval(): boolean {
        return this.marginApprovalReason.trim().length >= CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH;
    }

    onCreditLimitProceedCancel(): void {
        this.creditLimitProceedDialogVisible = false;
        this.creditLimitProceedCallback = null;
        this.creditLimitApprovalReason = '';
        this.creditLimitApprovalSubmitting = false;
    }

    onCreditLimitProceedAccept(): void {
        const cb = this.creditLimitProceedCallback;
        if (!this.canSubmitCreditLimitApproval) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Reason required',
                detail: `Enter at least ${CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH} characters.`,
                life: 3000
            });
            return;
        }
        const orderNumber = String(this.item?.orderNumber || this.invoiceDetails?.orderNumber || '').trim();
        if (!orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot approve',
                detail: 'Order number is missing.',
                life: 4000
            });
            return;
        }
        this.creditLimitApprovalSubmitting = true;
        this.productService.approveCreditLimit(orderNumber, this.creditLimitApprovalReason.trim()).subscribe({
            next: (res) => {
                this.creditLimitApprovalSubmitting = false;
                if (res?.success === false) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Approval failed',
                        detail: res?.errorMessage || res?.message || 'Could not save credit approval.',
                        life: 5000
                    });
                    return;
                }
                if (this.item) {
                    this.item.creditLimitApproved = true;
                    this.item.creditLimitApprovedBy = res?.creditLimitApprovedBy;
                    this.item.creditLimitApprovedAt = res?.creditLimitApprovedAt;
                    this.item.creditLimitApprovalReason =
                        res?.creditLimitApprovalReason ?? this.creditLimitApprovalReason.trim();
                }
                this.pendingCreditRestriction = null;
                this.creditLimitAcknowledged = true;
                this.creditLimitProceedDialogVisible = false;
                this.creditLimitProceedCallback = null;
                this.creditLimitApprovalReason = '';
                cb?.();
            },
            error: (err) => {
                this.creditLimitApprovalSubmitting = false;
                const msg =
                    typeof err?.error === 'string'
                        ? err.error
                        : err?.error?.errorMessage || err?.error?.message || 'Could not save credit approval.';
                this.messageService.add({ severity: 'error', summary: 'Approval failed', detail: msg, life: 5000 });
            }
        });
    }


    private configureCreditLimitDialog(restriction: CreditRestrictionResult): void {
        const mapped = mapCreditRestrictionToDialog(restriction);
        this.creditLimitDialogKind = mapped.kind;
        this.creditLimitDialogNood = mapped.nood;
        this.creditLimitDialogOdud = mapped.odud;
        this.creditLimitDialogData = mapped.data;
    }

    get creditLimitProceedNote(): string {
        return formatCreditLimitDialogNote(
            this.creditLimitDialogKind,
            this.creditLimitDialogNood,
            this.creditLimitDialogOdud,
            this.creditLimitDialogData,
            'You may continue.'
        );
    }

    get creditLimitBlockedNote(): string {
        return formatCreditLimitDialogNote(
            this.creditLimitDialogKind,
            this.creditLimitDialogNood,
            this.creditLimitDialogOdud,
            this.creditLimitDialogData,
            '',
            this.creditLimitContactNote
        );
    }

    onCreditLimitBlockedDialogClose(): void {
        this.creditLimitBlockedDialogVisible = false;
    }

    fetchInvoiceData(orderNumber: string, companyId: string, divisionId: string, isPreview: boolean = false) {
        this.isPreviewMode = isPreview;
        this.activeDivisionId = divisionId;
        this.loaderService.show(isPreview ? 'Generating Preview' : 'Fetching Invoice Data', 'Please wait...');
        
        const status = isPreview ? 'PREVIEW' : 'INV';
        const url = `${environment.apiUrl}InvoiceAndPicklist/generateOutput?companyId=${companyId}&divisionId=${divisionId}&orderNumber=${orderNumber}&orderMovingStatus=${status}`;

        this.http.get<any>(url).subscribe({
            next: (data) => {
                setTimeout(() => {
                    this.loaderService.hide();
                }, 300);

                this.handleCreditLimitFromGenerateOutput(data, divisionId);
                this.applyInvoiceData(data);
            },
            error: (error) => {
                this.loaderService.hide();
                console.error('Error loading invoice data:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load invoice data.'
                });
            }
        });
    }

    private applyInvoiceData(data: any): void {
                // Map supplier details
                this.supplierDetails = {
                    supplerVrno: data.supplierDetails?.vrno || '',
                    coa1: data.supplierDetails?.coa1 || '',
                    phno: data.supplierDetails?.phno || '',
                    coa2: data.supplierDetails?.coa2 || '',
                    coa3: data.supplierDetails?.coa3 || '',
                    coa4: data.supplierDetails?.coa4 || ''
                };

                // Map customer details
                this.customerDetails = {
                    customerVrno: data.customerDetails?.customerVrno || '',
                    CUA1: data.customerDetails?.customerAddress || '',
                    CUA2: '',
                    CUA3: '',
                    CUA4: '',
                    phoneNumber: data.customerDetails?.phoneNumber || '',
                    email: data.customerDetails?.email || ''
                };

                // Map invoice details
                this.invoiceDetails = {
                    invoiceNo: data.invoiceDetails?.invoiceNo || '',
                    customerNo: data.invoiceDetails?.customerNo || '',
                    date: data.invoiceDetails?.date || '',
                    orderNumber: data.invoiceDetails?.orderNumber || '',
                    referenceOrderNumber: data.invoiceDetails?.referenceOrderId || '',
                    userIdResponsible:
                        data.invoiceDetails?.userIdResponsible || this.item?.userIdResponsible || ''
                };

                this.marginSnapshot = data.marginSnapshot ?? null;
                this.marginCheckLines = this.mapLineDetailsForMarginCheck(data.lineDetails || []);

                this.headerPreTexts = this.normalizeTextList(data?.headerPreTexts);
                this.headerPostTexts = this.normalizeTextList(data?.headerPostTexts);

                // Map line details
                this.lineDetails = (data.lineDetails || []).map((line: any) => {
                    const netExVat = this.resolvePreviewLineNetExVat(line);
                    return {
                        position: line.lineNo,
                        itemNo: line.itemNo,
                        quantity: line.quantity,
                        description: line.description,
                        size: line.size || '',
                        pcs: line.pcs,
                        salesPrice: line.salesPrice,
                        discountPercent: line.discountPercent,
                        ppu: this.resolvePreviewPpu(line, netExVat),
                        lineTotalExVat: netExVat,
                        grossWeight: line.grossWeight,
                        linePreTexts: this.normalizeTextList(line?.linePreTexts),
                        linePostTexts: this.normalizeTextList(line?.linePostTexts)
                    };
                });

                const paginated = this.paginateByWrappedLines(this.lineDetails);
                this.summaryOnExtraPage = paginated.summaryOnExtraPage;
                this.paginatedContent = this.buildPreviewPages(this.lineDetails);

                // Map summary
                this.summary = {
                    grossValue: data.summaryLevelData?.grossValue || 0,
                    totalDiscountValue: data.summaryLevelData?.totalDiscountValue || 0,
                    netAmount: data.summaryLevelData?.netAmount || 0,
                    vatAmount: data.summaryLevelData?.vatAmount || 0,
                    totalOrderValue: data.summaryLevelData?.orderValue || 0,
                    totalGrossWeight: Math.round((Number(data.summaryLevelData?.totalGrossWeight) || 0) * 100) / 100,
                    vatPercent: data.summaryLevelData?.vatPercent || 0,
                    taxBase: data.summaryLevelData?.taxBase || 0,
                    vatSummaries: data.summaryLevelData?.vatSummaries || []
                };
    }

    selectedLanguage = 'en'; // default

    labels: { [lang: string]: { [key: string]: string } } = {
        en: {
            // invoiceTitle: 'Invoice',
            invoiceNo: 'Invoice no.',
            customerNo: 'Customer no.',
            date: 'Date',
            orderNumber: 'Order number',
            referenceOrderNumber: 'Reference Order ID',
            position: 'Pos',
            itemNo: 'Item<br>no.',
            quantity: 'Quantity',
            description: 'Name',
            size: 'Size',
            pcs: 'Pck',
            price: 'Sales<br>price',
            discount: 'Disc%',
            ppu: 'PPU',
            amount: 'EUR',
            vatCode: 'VAT Code',
            grossValue: 'Gross Value',
            totalDiscountValue: 'Total Discount Value',
            netAmount: 'Net Amount',
            vatAmount: 'VAT Amount',
            orderValue: 'Order Value',
            supplierIdentNo: 'Supplier Ident No:',
            customerIdentNo: 'Customer Ident No:',
            grossWeight: 'Gross Weight:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'VAT %',
            taxBaseLabel: 'Tax Base',
            vatAmountLabel: 'VAT Amount',
            orderConfirmation: 'Order confirmation',
            salesPerson: 'Sales person'
        },
        de: {
            // invoiceTitle: 'Rechnung',
            invoiceNo: 'Rechn.Nr.',
            customerNo: 'Kunden-Nr.',
            date: 'Datum',
            orderNumber: 'Auftragsnr.',
            referenceOrderNumber: 'Referenznr.',
            position: 'Pos',
            itemNo: 'Art.-<br>Nr.',
            quantity: 'Menge',
            description: 'Bezeichnung',
            size: 'Inhalt',
            pcs: 'Pack',
            price: 'Verkaufs-<br>preis',
            discount: 'Rabatt<br>%',
            ppu: 'PPU',
            amount: 'EUR',
            vatCode: 'MwSt Code',
            grossValue: 'Bruttowert',
            totalDiscountValue: 'Gesamtrabattwert',
            netAmount: 'Nettobetrag',
            vatAmount: 'Mehrwertsteuerbetrag',
            orderValue: 'Gesamtbetrag',
            supplierIdentNo: 'Lieferanten Ident Nr:',
            customerIdentNo: 'Kunden Ident Nr:',
            grossWeight: 'Brutto Gewicht:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'MwSt %',
            taxBaseLabel: 'Steuergrundlage',
            vatAmountLabel: 'MwSt-Betrag',
            preview: 'Preview',
            orderConfirmation: 'Auftragsbestätigung',
            salesPerson: 'Sales person'
        },
        nl: {
            // invoiceTitle: 'factuur',
            invoiceNo: 'Factuurnr.',
            customerNo: 'Klantnr.',
            date: 'Datum',
            orderNumber: 'Ordernr.',
            referenceOrderNumber: 'Referentie Ordernr.',
            position: 'sr.<br>nr',
            itemNo: 'Artikel<br>nr.',
            quantity: 'Hoeveel-<br>heid',
            description: 'Omschrij-<br>ving',
            size: 'Inhoud',
            pcs: 'Pak',
            price: 'Verkoop-<br>prijs',
            discount: 'Korting<br>%',
            ppu: 'PPU',
            amount: 'EUR',
            vatCode: 'BTW Code',
            grossValue: 'Brutowaarde',
            totalDiscountValue: 'Totale korting',
            netAmount: 'Netto bedrag',
            vatAmount: 'BTW-bedrag',
            orderValue: 'Totaalbedrag',
            supplierIdentNo: 'Leverancier Ident Nr:',
            customerIdentNo: 'Klant Ident Nr:',
            grossWeight: 'Bruto gewicht:',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'BTW %',
            taxBaseLabel: 'Grondslag',
            vatAmountLabel: 'BTW-bedrag',
            preview: 'Preview',
            orderConfirmation: 'Orderbevestiging',
            salesPerson: 'Sales person'
        },
        fr: {
            // invoiceTitle: 'Facture',
            invoiceNo: 'N° de facture',
            customerNo: 'N° client',
            date: 'Date',
            orderNumber: 'N° de commande',
            referenceOrderNumber: 'N° de commande de référence',
            position: 'N°',
            itemNo: 'N°<br>article',
            quantity: 'Qté',
            description: 'Désign.',
            size: 'Cont.',
            pcs: 'Cond.',
            price: 'Prix<br>vente',
            discount: 'Remise<br>%',
            ppu: 'PPU',
            amount: 'EUR',
            vatCode: 'Code TVA',
            grossValue: 'Valeur brute',
            totalDiscountValue: 'Valeur totale de remise',
            netAmount: 'Montant net',
            vatAmount: 'Montant TVA',
            orderValue: 'Valeur de commande',
            supplierIdentNo: 'N° d’identification fournisseur :',
            customerIdentNo: 'N° d’identification client :',
            grossWeight: 'Poids brut :',
            vatCodeLabel: 'Code',
            vatPercentLabel: 'TVA %',
            taxBaseLabel: 'Base taxable',
            vatAmountLabel: 'Montant TVA',
            preview: 'Preview',
            orderConfirmation: 'Confirmation de commande',
            salesPerson: 'Sales person'
        }
    };
    confirmAndInvoice() {
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }
        this.runPreviewSyncGates(() => {
            this.confirmInvoiceDialogVisible = true;
        });
    }

    confirmAndGenerateInvoice() {
        this.confirmInvoiceDialogVisible = false;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        this.loaderService.show('Invoicing Order', 'Please wait...');
        this.fetchInvoiceData(this.item.orderNumber, companyId, divisionId, false);
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Order has been invoiced successfully.'
        });
    }

    openSendPreviewMailDialog() {
        const apiEmail = (this.customerDetails?.email || '').trim();
        if (apiEmail) {
            this.sendPreviewMailTo = apiEmail;
        } else {
            this.sendPreviewMailTo = '';
        }
        this.sendPreviewMailDialogVisible = true;
    }
    get hasCustomerEmailFromApi(): boolean {
        return !!((this.customerDetails?.email || '').trim());
    }

    sendPreviewOnMail() {
        const toEmail = (this.sendPreviewMailTo || '').trim();
        if (!toEmail) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Email required',
                detail: this.hasCustomerEmailFromApi ? 'Please enter a recipient email address.' : 'Mail id not found for customer. Please enter email.'
            });
            return;
        }
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || this.div1 || '';
        this.sendPreviewMailLoading = true;
        const url = `${environment.apiUrl}InvoiceAndPicklist/sendPreviewOnMail`;
        const body = {
            orderNumber: this.item.orderNumber,
            companyId,
            divisionId,
            toEmail,
            language: this.selectedLanguage || 'en'
        };
        this.http.post<{ success?: boolean; message?: string }>(url, body).subscribe({
            next: (res) => {
                this.sendPreviewMailLoading = false;
                this.sendPreviewMailDialogVisible = false;
                this.sendPreviewMailTo = '';
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: res?.message || `Preview email sent to ${toEmail}.`
                });
            },
            error: (err) => {
                this.sendPreviewMailLoading = false;
                const msg = err?.error?.message || err?.error?.error || err?.message || 'Failed to send preview email.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Send failed',
                    detail: msg,
                    life: 5000
                });
            }
        });
    }

    confirmSyncToM3() {
        this.runPreviewSyncGates(() => this.continueConfirmSyncToM3AfterCredit());
    }

    /**
     * Sync / Confirm gates.
     * Normal user: credit limit first, then M3 customer block (Overdue Balance before BLCD=2 block).
     * Approver: customer block first — if BLCD != 0, Customer blocked; else Approve & Continue on accept.
     */
    private runPreviewSyncGates(onAllowed: () => void): void {
        const divisionId = String(this.getMarginDivisionId() || this.inMemoryStorage.get('division') || '');
        const isApprover = isCreditLimitSoftBypassUser(resolveUserEmail(this.inMemoryStorage), divisionId, 'sync');

        if (isApprover) {
            this.runCustomerBlockCheckThen(() => {
                if (this.handleCreditLimitBeforeSyncOrInvoice(onAllowed)) {
                    return;
                }
                onAllowed();
            });
            return;
        }

        const afterCreditLimitGate = () => {
            this.runCustomerBlockCheckThen(onAllowed);
        };
        if (this.handleCreditLimitBeforeSyncOrInvoice(afterCreditLimitGate)) {
            return;
        }
        afterCreditLimitGate();
    }

    /** M3 BLCD must be 0 unless credit-limit gate already handled the salesperson over-limit case. */
    private runCustomerBlockCheckThen(onAllowed: () => void): void {
        const customerId = this.item?.customerId || this.invoiceDetails?.customerNo || this.item?.customer || '';
        const companyId = this.userService.getCompanyId() || this.inMemoryStorage.get('company') || '';
        const divisionId = this.getMarginDivisionId() || this.inMemoryStorage.get('division') || '';
        this.loaderService.show('Checking customer status...', 'Please wait...');
        this.productService.checkCustomerBlock(customerId, companyId, divisionId).subscribe({
            next: (blockCheck) => {
                this.loaderService.hide();
                if (!blockCheck?.allowed) {
                    this.customerBlockedDialogMessage =
                        blockCheck?.message ||
                        `Customer ${blockCheck?.cuno || customerId} is blocked in M3 (block code ${blockCheck?.blcd || 'n/a'}). Sync is not allowed until the customer block is cleared.`;
                    this.customerBlockedDialogVisible = true;
                    return;
                }
                onAllowed();
            },
            error: (err) => {
                this.loaderService.hide();
                const msg =
                    typeof err.error === 'string'
                        ? err.error
                        : err.error?.message || 'Could not verify customer block status in M3.';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Customer Check Failed',
                    detail: msg,
                    life: 5000
                });
            }
        });
    }

    private continueConfirmSyncToM3AfterCredit(): void {
        this.checkMarginBeforeSync(() => this.showSyncConfirmDialog());
    }

    private showSyncConfirmDialog(): void {
        const orderNumber = this.item?.orderNumber || 'this order';
        this.confirmationService.confirm({
            message: `Are you sure you want to sync order ${orderNumber} to M3?`,
            header: 'Confirm Sync to M3',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.syncToM3();
            }
        });
    }

    private mapLineDetailsForMarginCheck(content: any[]): any[] {
        return (content || []).map((line: any) => ({
            itemNumber: line.itemNo || line.itemNumber || '',
            itemName: line.description || line.itemName || '',
            quantity: line.quantity ?? line.qty ?? 0,
            amountAfterDiscount: line.netAmount ?? line.amountAfterDiscount ?? 0,
            cost: line.costPrice ?? line.cost,
            costPrice: line.costPrice ?? line.cost,
            minimumMargin: line.itemMcm ?? line.minimumMargin,
            itemMcm: line.itemMcm ?? line.minimumMargin,
            calculatedMargin: line.calculatedMargin
        }));
    }

    private linesHaveMarginData(lines: any[]): boolean {
        return (lines || []).some(
            (line) =>
                line?.cost != null ||
                line?.costPrice != null ||
                line?.minimumMargin != null ||
                line?.itemMcm != null
        );
    }

    private getMarginDivisionId(): string {
        return this.activeDivisionId || this.div1 || this.userService.getDivisionId() || this.item?.divisionId || '';
    }

    private getMarginWarehouse(): string {
        return resolveMarginWarehouse({
            warehouseId: this.item?.warehouseId,
            whsId: this.item?.whsId ?? this.marginSnapshot?.whsId,
            warehouse: this.item?.warehouse,
            storageWarehouseId: this.inMemoryStorage.get('warehouseId')
        });
    }

    private getOrderMinimumMarginPercent(): number {
        return resolveOrderMinimumMarginPercent({
            orderMcm: this.marginSnapshot?.orderMcm ?? this.item?.orderMcm,
            minimumOrderMargin: this.item?.minimumOrderMargin,
            F1N096: this.item?.F1N096
        });
    }

    private showMarginApprovalResult(summary: MarginApprovalSummary, onAllowed: () => void): void {
        const divisionId = this.getMarginDivisionId();
        const warehouse = this.getMarginWarehouse();
        this.marginApprovalSummary = summary;
        this.marginApprovalContactNote = getMarginBypassContactNote(divisionId, warehouse, 'sync');
        if (isMarginApprovalUserFromStorage(this.inMemoryStorage, divisionId, warehouse)) {
            this.marginApprovalContactEmails = resolveMarginAssistanceContactEmails(divisionId, warehouse);
            this.marginApprovalProceedLabel = 'Sync to M3';
            this.marginApprovalProceedNote = getMarginApproverProceedNote('Sync to M3');
            this.marginApprovalReason = '';
            this.marginApprovalSubmitting = false;
            this.marginApprovalProceedCallback = onAllowed;
            this.marginApprovalProceedDialogVisible = true;
            return;
        }
        this.marginApprovalContactEmails = resolveMarginBlockedContactEmails(
            divisionId,
            warehouse,
            resolveUserEmail(this.inMemoryStorage)
        );
        this.marginApprovalBlockedNotice = getMarginBlockedApprovalNotice('sync');
        this.marginApprovalBlockedDialogVisible = true;
    }

    private evaluateMarginAndProceed(onAllowed: () => void, itemList: any[]): void {
        const summary = buildMarginApprovalSummary(
            this.marginValidationService,
            itemList,
            this.getOrderMinimumMarginPercent()
        );
        if (!summary.hasAnyViolation) {
            onAllowed();
            return;
        }
        this.showMarginApprovalResult(summary, onAllowed);
    }

    private checkMarginBeforeSync(onAllowed: () => void): void {
        const divisionId = this.getMarginDivisionId();
        if (!isMarginApprovalEnabledForDivision(divisionId)) {
            onAllowed();
            return;
        }
        if (shouldSkipMarginProcessingGate(
            this.item?.referenceOrderId ?? this.marginSnapshot?.referenceOrderId,
            this.item ?? this.marginSnapshot
        )) {
            onAllowed();
            return;
        }
        const orderTypeId = String(this.marginSnapshot?.orderTypeId ?? this.item?.orderTypeId ?? '');
        if (isCreditNoteOrder(divisionId, orderTypeId)) {
            onAllowed();
            return;
        }
        if (this.marginSnapshot?.marginBelowMinimum === false) {
            onAllowed();
            return;
        }

        if (this.linesHaveMarginData(this.marginCheckLines)) {
            this.evaluateMarginAndProceed(onAllowed, this.marginCheckLines);
            return;
        }

        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || this.inMemoryStorage.get('company') || '';
        if (!orderNumber) {
            onAllowed();
            return;
        }

        this.loaderService.show('Checking contribution margin...', 'Please wait...');
        this.itemDetailsService.getOrderLines(orderNumber, companyId, divisionId).subscribe({
            next: (linesResponse: any) => {
                this.loaderService.hide();
                const itemList = this.mapLineDetailsForMarginCheck(linesResponse?.content || []);
                this.evaluateMarginAndProceed(onAllowed, itemList);
            },
            error: () => {
                this.loaderService.hide();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Margin Check Failed',
                    detail: 'Could not load order lines for margin validation.',
                    life: 4000
                });
            }
        });
    }

    onMarginApprovalProceedCancel(): void {
        this.marginApprovalProceedDialogVisible = false;
        this.marginApprovalProceedCallback = null;
        this.marginApprovalReason = '';
        this.marginApprovalSubmitting = false;
    }

    onMarginApprovalProceedAccept(): void {
        const cb = this.marginApprovalProceedCallback;
        if (!this.canSubmitMarginApproval) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Reason required',
                detail: `Enter at least ${CREDIT_LIMIT_APPROVAL_REASON_MIN_LENGTH} characters.`,
                life: 3000
            });
            return;
        }
        const orderNumber = String(this.item?.orderNumber || this.invoiceDetails?.orderNumber || '').trim();
        if (!orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Cannot approve',
                detail: 'Order number is missing.',
                life: 4000
            });
            return;
        }
        this.marginApprovalSubmitting = true;
        this.productService.approveMargin(orderNumber, this.marginApprovalReason.trim()).subscribe({
            next: (res) => {
                this.marginApprovalSubmitting = false;
                if (res?.success === false) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Approval failed',
                        detail: res?.errorMessage || res?.message || 'Could not save margin approval.',
                        life: 5000
                    });
                    return;
                }
                if (this.item) {
                    this.item.marginApproved = true;
                    this.item.marginApprovedBy = res?.marginApprovedBy;
                    this.item.marginApprovedAt = res?.marginApprovedAt;
                    this.item.marginApprovalReason =
                        res?.marginApprovalReason ?? this.marginApprovalReason.trim();
                }
                this.marginApprovalProceedDialogVisible = false;
                this.marginApprovalProceedCallback = null;
                this.marginApprovalReason = '';
                cb?.();
            },
            error: (err) => {
                this.marginApprovalSubmitting = false;
                const msg =
                    typeof err?.error === 'string'
                        ? err.error
                        : err?.error?.errorMessage || err?.error?.message || 'Could not save margin approval.';
                this.messageService.add({ severity: 'error', summary: 'Approval failed', detail: msg, life: 5000 });
            }
        });
    }

    onMarginApprovalBlockedDialogDismiss(): void {
        this.marginApprovalBlockedDialogVisible = false;
    }

    onMarginApprovalBlockedDialogOk(): void {
        this.marginApprovalBlockedDialogVisible = false;
    }

        alreadySyncedDialogVisible: boolean = false;
        alreadySyncedDialogMessage: string = '';
        customerBlockedDialogVisible: boolean = false;
        customerBlockedDialogMessage: string = '';
    syncToM3() {
        if (this.creditLimitBlocked) {
            return;
        }
        if (!this.item?.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Order number is required.'
            });
            return;
        }
        this.loaderService.show('Syncing order to M3...', 'Please wait...');
        this.productService
            .syncSingleOrderToM3(this.item.orderNumber, 'CustomerOrder')
            .subscribe({
                next: () => {
                    this.loaderService.hide();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Sync Completed',
                        detail: `Order ${this.item.orderNumber} synced to M3 successfully. Invoice will appear in the invoice column.`,
                        life: 4000
                    });
                    this.skipReleaseLock = false;
                    this.router.navigate(['/Orders1']);
                },
                error: (err) => {
                    this.loaderService.hide();
                    const apiErrorCode = err?.error?.errorCode;
                    const apiMessage = err?.error?.message || '';
                    const isAlreadySyncedError = apiErrorCode === 'ORDER_ALREADY_SYNCED' || /already\s+synced/i.test(apiMessage);
                    if (isAlreadySyncedError) {
                        this.alreadySyncedDialogMessage = apiMessage || 'Order is already synced with Infor M3';
                        this.alreadySyncedDialogVisible = true;
                        setTimeout(() => {
                            this.alreadySyncedDialogVisible = false;
                            this.skipReleaseLock = false;
                           this.router.navigate(['/Orders1']);
                     }, 4000);
                       return;
                   }
                    if (apiErrorCode === 'CUSTOMER_BLOCKED') {
                        this.customerBlockedDialogMessage =
                            apiMessage || 'Customer is blocked in M3. Sync is not allowed until the customer block is cleared.';
                        this.customerBlockedDialogVisible = true;
                        return;
                    }
                    const isConflict = err?.status === 409 || err?.status === 423;
                    this.messageService.add({
                        severity: isConflict ? 'warn' : 'error',
                        summary: isConflict ? 'Sync In Progress' : 'Sync Failed',
                        detail: err?.error?.message || (isConflict ? 'Syncing in progress, please try later.' : 'Failed to sync order to M3.'),
                        life: 4000
                    });
                }
            });
    }
    getLabel(key: string): string {
        return this.labels[this.selectedLanguage][key] || key;
    }

    getAddressLines(address: string): string[] {
        return address
            ? address
                  .split('|')
                  .map((line) => line.trim())
                  .filter((line) => line)
            : [];
    }

    // getPhoneLines(phone: string): string[] {
    //     return phone
    //         ? phone.split('|').map((line) => line.trim()).filter((line) => line)
    //         : [];
    // }

    startLockRefresh() {
        this.refreshOrderLock(); // Call once immediately
        this.lockRefreshInterval = setInterval(() => {
            this.refreshOrderLock();
        }, 30 * 1000); // 30 seconds
    }

    refreshOrderLock() {
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        const currentUsername = this.userService.getUserName?.() || 'unknown';

        if (orderNumber && companyId && divisionId && currentUsername) {
            const url = `${environment.apiUrl}orders/lock/lockrefresh?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;

            // const url = `http://192.168.31.92:8444/orders/lock/lockrefresh?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;
            this.http.post(url, {}).subscribe({
                next: () => console.log('Order lock refreshed (picking list)'),
                error: () => console.warn('Order lock refresh failed (picking list)')
            });
        }
    }

    releaseOrderLock() {
        const orderNumber = this.item?.orderNumber;
        const companyId = this.userService.getCompanyId() || '';
        const divisionId = this.userService.getDivisionId() || '';
        const currentUsername = this.userService.getUserName?.() || 'unknown';

        if (orderNumber && companyId && divisionId && currentUsername) {
            const url = `${environment.apiUrl}orders/lock/release?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;

            // const url = `http://192.168.31.92:8444/orders/lock/release?orderNumber=${orderNumber}&companyId=${companyId}&divisionId=${divisionId}&currentUsername=${currentUsername}`;
            this.http.post(url, {}).subscribe({
                next: () => console.log('Order lock released (picking list)'),
                error: () => console.warn('Order lock release failed (picking list)')
            });
        }
    }

    getPhoneLines(phone: string): string[] {
        return phone
            ? phone
                  .split('|')
                  .map((line) => line.trim())
                  .filter((line) => line)
            : [];
    }
    // Add in ngOnDestroy
    ngOnDestroy() {
        console.log('Component destroyed, releasing order lock');

        // Do not release lock when navigating to order (Go to Order) so user keeps editing
        if (!this.skipReleaseLock) {
            this.releaseOrderLock();
        }

        clearInterval(this.lockRefreshInterval);
    }
}
